import { domScheduler } from "@studiometa/js-toolkit/utils";
import { fallbackStore as store } from "../utils/storage/index.js";
const headerVisibilities = /* @__PURE__ */ new Set(["visible", "hidden"]);
const defaultHeaderVisibility = "visible";
const key = "header";
const callbacks = [];
function getHeaderVisibility() {
  return store.get(key) || defaultHeaderVisibility;
}
function headerIs(position) {
  return getHeaderVisibility() === position;
}
function headerIsVisible() {
  return headerIs("visible");
}
function headerIsHidden() {
  return headerIs("hidden");
}
function headerUpdateDOM(value = getHeaderVisibility()) {
  domScheduler.write(() => {
    document.documentElement.classList.toggle("has-header", value === "visible");
  });
}
function setHeaderVisibility(value = getHeaderVisibility()) {
  if (!headerVisibilities.has(value)) {
    console.warn(`The "${value}" header visibility is not valid.`);
    value = defaultHeaderVisibility;
  }
  store.set(key, value);
  headerUpdateDOM(value);
  callbacks.forEach((callback) => callback(value));
}
function watchHeaderVisibility(callback) {
  const index = callbacks.length;
  callbacks.push(callback);
  return () => {
    callbacks.splice(index, 1);
  };
}
export {
  getHeaderVisibility,
  headerIs,
  headerIsHidden,
  headerIsVisible,
  headerUpdateDOM,
  setHeaderVisibility,
  watchHeaderVisibility
};
//# sourceMappingURL=header.js.map
